<template>
    <div>
        <nav
            class="d-flex justify-content-center"
            aria-label="Page navigation"
            v-if="data && data.last_page > 1"
        >
            <ul class="pagination mb-0">
                <li class="page-item" v-if="data.current_page > 1">
                    <a class="page-link" @click="onNavClick(1)" aria-label="Previous">
                        <i class="material-icons uhe-pag-icon">first_page</i>
                    </a>
                </li>
                <li class="page-item" v-if="data.current_page > 1">
                    <a
                        class="page-link"
                        @click="onNavClick(data.current_page - 1)"
                        aria-label="Previous"
                    >
                        <i class="material-icons uhe-pag-icon">chevron_left</i>
                    </a>
                </li>
                <li class="page-item" v-if="data.current_page > 1">
                    <a
                        class="page-link"
                        @click="onNavClick(data.current_page - 1)"
                    >{{data.current_page - 1}}</a>
                </li>
                <li class="page-item">
                    <a class="page-link">{{data.current_page}}</a>
                </li>
                <li class="page-item" v-if="data.current_page < data.last_page">
                    <a
                        class="page-link"
                        @click="onNavClick(data.current_page + 1)"
                    >{{data.current_page + 1}}</a>
                </li>
                <li class="page-item" v-if="data.current_page < data.last_page">
                    <a
                        class="page-link"
                        @click="onNavClick(data.current_page + 1)"
                        aria-label="Next"
                    >
                        <i class="material-icons uhe-pag-icon">chevron_right</i>
                    </a>
                </li>
                <li class="page-item" v-if="data.current_page < data.last_page">
                    <a class="page-link" @click="onNavClick(data.last_page)" aria-label="Next">
                        <i class="material-icons uhe-pag-icon">last_page</i>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    props: {
        data: Object,
        required: true
    },
    methods: {
        onNavClick(newPage) {
            this.$emit("changePage", newPage);
        }
    }
};
</script>

<style scoped>
</style>

